export default __webpack_public_path__ + "static/image13-e4c98f140d493e16ea4bcebc7b6f890b.gif";